/* unplugin-vue-components disabled */import script from "./youtube.vue?vue&type=script&lang=js"
export * from "./youtube.vue?vue&type=script&lang=js"

import "./youtube.vue?vue&type=style&index=0&id=85063642&lang=scss"

const __exports__ = script;

export default __exports__